import { IonButton } from '@ionic/react';
import { ReactNode, useState } from 'react';
import { DrawerLabel } from '../drawer/DrawerLabel.tsx';
import { DownChevronIcon, UpChevronIcon } from '../icons/Icons.tsx';
import { Card } from './Card.tsx';
import { CardContent } from './CardContent.tsx';
import { CardHeader } from './CardHeader.tsx';

export const ExpandableCard: React.FC<{heading: string, children: ReactNode}> = ({heading, children}) => {
    const [isOpen, setOpen] = useState(true);
    return (
        <Card>
            <CardHeader>
                <div style={{display: 'flex', justifyContent: 'space-between'}} onClick={() => setOpen(!isOpen)}>
                    <span style={{flexGrow: 1}}><DrawerLabel text={heading} /></span>
                    <IonButton style={{margin: '-5px -20px'}} size="small" fill="clear">
                        {!isOpen && <DownChevronIcon size="small" />}
                        {isOpen && <UpChevronIcon size="small" />}
                    </IonButton>
                </div>
            </CardHeader>
            {isOpen &&
                <CardContent>
                    {children}
                </CardContent>
            }
        </Card>
    );
};
